<div id="query-name" class="layout-col-gap-025">
  <div class="layout-row-gap-025 layout-align-center">
    <label for="name">Name</label>
    <input id="name" type="text" [(ngModel)]="queryName" [disabled]="!!query?.isSystem || !!query?.isDefault" tabindex="0"
      class="noMatFormControl">
  </div>
  @if (errorMessages.has('Name')) {
  <div class="errorText">{{ errorMessages.get('Name') }}.</div>
  }
</div>
<div style="margin-left:1em;margin-bottom:1em;">
  <mat-slide-toggle [(ngModel)]="allowOperator">
    Allow Operator Access
  </mat-slide-toggle>
</div>
<!-- filters *********************** -->
@if (queryColumns.data.length) {
<mat-table [dataSource]="queryColumns">
  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef style="flex: 1;">Column</mat-header-cell>
    <mat-cell *matCellDef="let column" style="padding:0 8px; flex: 1; min-width: 0;">
      <mat-select [(ngModel)]="column.key" [title]="column.key" [panelWidth]="null" class="noMatFormControl"
        style="width:100%;">
        <mat-optgroup label="Normal Columns">
          @for (value of userColumns();track value.id) {
          <mat-option [value]="value.id">
            {{ value.name }}
          </mat-option>
          }
        </mat-optgroup>
        <mat-optgroup label="System Columns">
          @for (value of systemColumns(); track value) {
          <mat-option [value]="value.id">
            {{ value.name }}
          </mat-option>
          }
        </mat-optgroup>
      </mat-select>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="filter">
    <mat-header-cell *matHeaderCellDef style="flex: 0 0 146px;">Filter Value</mat-header-cell>
    <mat-cell *matCellDef="let column" style="padding:0px; flex: 0 0 146px;">
      <input type="text" [(ngModel)]="column.value.new" class="noMatFormControl" style="width:110px;">
      <button (click)="remove(column)" mat-icon-button style="margin-top:-10px;margin-left:-10px"
        [title]="'Remove the filter on column ‘' + column.key + '’'">
        <mat-icon>close</mat-icon>
      </button>
    </mat-cell>
  </ng-container>
  <!--  <mat-footer-cell *matFooterCellDef class="mat-caption" colspan="2">-->
  <!--    Enter ? for filter value to be prompted.-->
  <!--  </mat-footer-cell>-->
  <mat-header-row *matHeaderRowDef="['name', 'filter']"></mat-header-row>
  <mat-row *matRowDef="let row; columns: ['name', 'filter']"></mat-row>
  <!--  <mat-footer-row *matFooterRowDef="['filter']"></mat-footer-row>-->
</mat-table>
}
@if (queryColumns.data.length !== allColumns.length) {
<button mat-button id="add-column-button" title="Add a new column filter to this query" color="primary"
  (click)="newColumn()">
  <mat-icon>add_circle</mat-icon>
  Add Column Filter
</button>
}
<!-- joins *********************** -->
<mat-card style="margin:0.25rem;" appearance="outlined">
  <mat-card-header>
    <mat-card-subtitle>Join Another Query</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <div class="layout-col-gap-1 layout-align-start layout-justify-evenly">
      <mat-slide-toggle [(ngModel)]="join">Enabled</mat-slide-toggle>
      @if (join) {
      <div class="layout-col-gap-05 layout-align-start layout-justify-evenly">
        <div class="layout-col-gap-025">
          <label for="joinName">Column Prefix</label>
          <input id="joinName" type="text" [disabled]="!join" matInput [(ngModel)]="joinName" required
            class="noMatFormControl">
          <!--                        <mat-hint>A distinct prefix is required for child columns.</mat-hint>-->
          @if (errorMessages.has('JoinName')) {
          <div class="mat-caption errorText" [innerHtml]="errorMessages.get('JoinName')">
          </div>
          }
        </div>
        <div class="layout-col-gap-025">
          <label for="joinToQueryID">Join To Query</label>
          <select id="joinToQueryID" [disabled]="!join" [(ngModel)]="joinToQueryID" (change)="joinQueryChanged($event)"
            class="noMatFormControl">
            @for (q of joinDataSources; track q) {
            <option [value]="q.query.id">
              {{ q.label }}
            </option>
            }
          </select>
        </div>
        <div class="layout-col-gap-025">
          <label for="joinParentField">Join Parent Column</label>
          <select id="joinParentField" [disabled]="!join" [(ngModel)]="joinParentField" class="noMatFormControl">
            @for (f of joinParentFields; track f) {
            <option [value]="f">
              {{ f }}
            </option>
            }
          </select>
        </div>
        <div class="layout-col-gap-025">
          <label for="joinChildField">Join Child Column</label>
          <select id="joinChildField" [disabled]="!join || !joinChildFields" [(ngModel)]="joinChildField"
            class="noMatFormControl">
            @for (f of joinChildFields; track f) {
            <option [value]="f">
              {{ f }}
            </option>
            }
          </select>
        </div>
        <mat-slide-toggle [disabled]="!join || !joinChildFields" [(ngModel)]="joinMustMatch">Must match
        </mat-slide-toggle>
      </div>
      }
    </div>
  </mat-card-content>
</mat-card>
<ng-template #cantJoin>
  <div style="margin:1em;">
    <p>Joins not possible. This query may already be used as a child query or there are no other queries to join
      to.</p>
  </div>
</ng-template>
<!-- actions *********************** -->
<div class="layout-row-gap-025" [class.is-editing]="isEditingQuery" style="padding: 4px">
  @if (isEditingQuery) {
  <button title="Discard changes made to this query" mat-button
    (click)="finished({save: false})">
    Cancel
  </button>
  }
  <button mat-raised-button color="primary" title="Save changes to this query" [disabled]="!isQueryValid"
    (click)="finished({save: true})">
    <mat-icon>save</mat-icon>
    Save
  </button>
  @if (query && !query.isDefault && !query.isSystem) {
  <button require="DatamanDeleteQuery" mat-stroked-button color="warn" title="Delete this query"
    (click)="dataSource.delete(query)">
    <mat-icon>delete</mat-icon>
    Delete
  </button>
  }
</div>
